import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyApiToken = lazyWithRetry(() => import('./apiToken'));
